import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolders: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folders"><path d="M1.75 7.75V20.25H18.25V9.75H10L8 7.75H1.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M18.2895 16.25H22.25V5.75H14L12 3.75H5.75V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconFolders;
